import Network from './network';

const REGISTRATIONS_ENDPOINT = 'API/Registrations';

export const GetMachineRegistrations = (params) => {
  let resp = Network.Get(REGISTRATIONS_ENDPOINT, params);
  return resp.data.items;
};